import script from "./AsideForType.vue?vue&type=script&setup=true&lang=js"
export * from "./AsideForType.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__